import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { TableFilterMenu } from '@interxfi/design-system/components/table/filter/table-filter-menu';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import {
  type BalanceSheetFilterableField,
  BalanceSheet as Report,
} from '../../../../../../../../../../features/accounting/balance-sheet/balance-sheet';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/balance-sheet/_balance-sheet/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingFinanceAccounting,
      label: 'Balance Sheet',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingFinanceAccounting>,
  head: () => getPageHead('Balance Sheet'),
  component: BalanceSheet,
});

function TableHeader({ filterProps }: CustomTableHeaderProps<BalanceSheetFilterableField>) {
  return (
    <PageTabRail
      actions={
        filterProps ? (
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            <TableFilterMenu<BalanceSheetFilterableField> {...filterProps} />
          </HorizontalStack>
        ) : null
      }
      group={TabbedNavigationGroup.ClearingFinanceAccounting}
    />
  );
}

function BalanceSheet() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <Report HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
